(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["number-counter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('number-counter')) {
    customElements.define('number-counter', class NumberCounter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.valueElement = this.querySelector('[data-number-counter-value]');
        this.target = Number.parseInt(this.dataset.target || '0', 10);
        this.duration = Number.parseInt(this.dataset.duration || '1600', 10);
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.valueElement || !Number.isFinite(this.target)) return;
        if (this.dataset.animate !== 'true' || this.reduceMotion || !('IntersectionObserver' in window)) {
          this.render(this.target);
          return;
        }

        this.render(0);
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.start();
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) window.cancelAnimationFrame(this.frame);
      }

      start() {
        if (this.hasAnimated) return;
        this.hasAnimated = true;
        const startedAt = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - startedAt) / Math.max(this.duration, 1), 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.render(Math.round(this.target * eased));

          if (progress < 1) {
            this.frame = window.requestAnimationFrame(tick);
          } else {
            this.render(this.target);
          }
        };

        this.frame = window.requestAnimationFrame(tick);
      }

      render(value) {
        this.valueElement.textContent = value.toLocaleString();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
